function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
/* eslint react/no-danger:0 */


import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import debounce from 'lodash.debounce';
import "./FormTextArea.css";
/**
 * FormTextArea Component
**/
// the values are used for computations related to autoExpand functionality
// these are default values that will be override upon componentDidMount if
// autoExpand feature is enabled, using the computesStyles from the textarea

var DEFAULT_COMPUTED_STYLE_VALUES = {
  borderWidth: 1,
  lineHeight: 24,
  maximumHeight: 0,
  paddingBottom: 8,
  paddingTop: 34
};

var FormTextArea =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(FormTextArea, _PureComponent);

  function FormTextArea(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;

    _this.handleChange = function (event) {
      if (_this.state.isDirty !== !!event.target.value) {
        _this.setState({
          isDirty: !!event.target.value
        });
      } // controlled components will autoExpand via componentDidUpdate


      if (_this.props.autoExpand && typeof _this.props.value !== 'string') {
        _this.autoExpand();
      }

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    _this.handleFocus = function (event) {
      if (!_this.state.hasFocus) {
        _this.setState({
          hasFocus: true
        });
      }

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    };

    _this.handleBlur = function (event) {
      if (_this.state.hasFocus) {
        _this.setState({
          hasFocus: false
        });
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    };

    _this.state = {
      isDirty: false,
      hasFocus: false,
      minRows: _this.props.rows || 0
    };
    _this.debouncedResize = debounce(_this.onResize, 250, {
      maxWait: 1000
    }).bind(_assertThisInitialized(_this)); // stored if autoExpand and (maxRows or maxHeight) configured for use.
    // is used to toggle overflow from hidden to auto when max height is reached

    _this.computedMaxHeight = 0;
    return _this;
  }

  var _proto = FormTextArea.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.textArea && this.props.autoExpand) {
      this.initializeAutoExpand({
        maxHeight: this.props.maxHeight,
        minRows: this.state.minRows,
        maxRows: this.props.maxRows
      });
    }
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.state.isDirty !== !!nextProps.value) {
      this.setState({
        isDirty: !!nextProps.value
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var valueChanged = this.props.value !== prevProps.value;

    if (this.props.autoExpand && valueChanged) {
      this.autoExpand();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.autoExpand && typeof window !== 'undefined') {
      window.removeEventListener('resize', this.debouncedResize);
    }
  };

  _proto.onResize = function onResize() {
    this.autoExpand();
  };

  _proto.autoExpand = function autoExpand() {
    // Set the height to 0, so we can get the correct content height via scrollHeight
    // Also, running this through state changes causes a race condition when decreasing scrollHeight.
    this.textArea.style.height = '0px'; // set height to scrollHeight, but add border-width * 2 since that is not reported in scrollHeight
    // but is used in box-sizing: border-box to determine height of textarea element

    var newHeight = this.textArea.scrollHeight + this.computedStyleValues.borderWidth * 2;
    this.textArea.style.height = newHeight + "px"; // if computedMaxHeight > 0, check to make sure overflow is appropriate

    if (this.computedMaxHeight > 0) {
      var overflow = this.textArea.style.overflow;

      if (overflow === 'hidden' && newHeight > this.computedMaxHeight) {
        this.textArea.style.overflow = 'auto';
      } else if (overflow === 'auto' && newHeight < this.computedMaxHeight) {
        this.textArea.style.overflow = 'hidden';
      }
    }
  };

  _proto.initializeAutoExpand = function initializeAutoExpand(_ref) {
    var _ref$maxHeight = _ref.maxHeight,
        maxHeight = _ref$maxHeight === void 0 ? 'none' : _ref$maxHeight,
        _ref$minRows = _ref.minRows,
        minRows = _ref$minRows === void 0 ? 0 : _ref$minRows,
        _ref$maxRows = _ref.maxRows,
        maxRows = _ref$maxRows === void 0 ? 0 : _ref$maxRows; // eslint-disable-line complexity

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.debouncedResize);
    }

    if (maxHeight) {
      this.textArea.style.maxHeight = maxHeight;
    } // set this.computedStyleValues with computed styles, passing in DEFAULT_COMPUTED_STYLE_VALUES
    // as default values. do this after setting maxHeight, so we can get a computed max-height, if set.


    this.computedStyleValues = this.getComputedStyleValues(DEFAULT_COMPUTED_STYLE_VALUES);

    if (!isNaN(this.computedStyleValues.maxHeight)) {
      this.computedMaxHeight = this.computedStyleValues.maxHeight;
    }

    if (minRows > 1) {
      this.textArea.style.minHeight = this.getHeightFromRows(minRows, this.computedStyleValues) + "px";
    }

    if (!this.props.maxHeight && maxRows > 0) {
      var maxHeightFromRows = this.getHeightFromRows(maxRows, this.computedStyleValues);
      this.textArea.style.maxHeight = maxHeightFromRows + "px";
      this.computedMaxHeight = maxHeightFromRows;
    }

    this.textArea.style.overflow = 'hidden';
    this.autoExpand();
  };

  _proto.getHeightFromRows = function getHeightFromRows(rows, computedStyleValues) {
    return rows * computedStyleValues.lineHeight + computedStyleValues.paddingTop + computedStyleValues.paddingBottom + computedStyleValues.borderWidth * 2;
  };

  _proto.getComputedStyleValues = function getComputedStyleValues(defaults) {
    if (this.textArea && typeof window !== 'undefined') {
      var computedStyle = window.getComputedStyle(this.textArea);
      return {
        borderWidth: this.getStyleValue('border-width', computedStyle, defaults.borderWidth),
        lineHeight: this.getStyleValue('line-height', computedStyle, defaults.lineHeight),
        maxHeight: this.getStyleValue('max-height', computedStyle, NaN),
        paddingBottom: this.getStyleValue('padding-bottom', computedStyle, defaults.paddingBottom),
        paddingTop: this.getStyleValue('padding-top', computedStyle, defaults.paddingTop)
      };
    }

    return defaults;
  };

  _proto.getStyleValue = function getStyleValue(property, computedStyle, defaultValue) {
    var value = parseInt(computedStyle.getPropertyValue(property), 10);
    return !isNaN(value) ? value : defaultValue;
  }
  /** Can be called exernally to force focus */
  ;

  _proto.focus = function focus() {
    this.textArea.focus();
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        label = _this$props.label,
        className = _this$props.className,
        helpText = _this$props.helpText,
        inverse = _this$props.inverse,
        errorMsg = _this$props.errorMsg,
        srOnlyLabel = _this$props.srOnlyLabel,
        autoExpand = _this$props.autoExpand,
        rest = _objectWithoutProperties(_this$props, ["label", "className", "helpText", "inverse", "errorMsg", "srOnlyLabel", "autoExpand"]);

    var hasError = !!errorMsg;
    var notEmpty = this.state.isDirty || this.props.value;
    var parentClasses = classNames(className, {
      'form-group': true,
      'floating-label': !srOnlyLabel,
      'not-empty': notEmpty,
      'empty': !notEmpty,
      'has-error': hasError
    }); // note that below, the disabled prop has not been destructured since it needs to
    // get passed through with ...rest to the textarea element to be used as an attribute

    var labelClasses = classNames('FormTextArea__floating-label', {
      'sr-only': srOnlyLabel,
      'FormTextArea__floating-label--has-error': hasError && !this.state.hasFocus,
      'FormTextArea__floating-label--disabled': this.props.disabled
    });
    var textAreaClasses = classNames('FormTextArea__textarea form-control', {
      'FormTextArea__textarea--auto-expand': autoExpand
    });
    var message = errorMsg || helpText;
    var messageId = this.props.id + "__help";

    var textareaProps = _extends({
      className: textAreaClasses,
      ref: function ref(c) {
        _this2.textArea = c;
      },
      onChange: this.handleChange,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur
    }, typeof label === 'string' && {
      'aria-label': label
    }, {}, message && {
      'aria-describedby': messageId
    }, {}, rest);

    var helpProps = _extends({
      className: classNames('help-block', {
        'text-white': inverse
      })
    }, errorMsg && {
      role: 'alert',
      'aria-live': 'polite'
    }); // These props are invalid in the native textarea, so pop them off.


    delete textareaProps.maxHeight;
    delete textareaProps.maxRows;
    return React.createElement("div", {
      className: parentClasses
    }, React.createElement("textarea", textareaProps), React.createElement("label", {
      className: labelClasses,
      htmlFor: this.props.id
    }, label), message && React.createElement("span", _extends({}, helpProps, {
      id: messageId,
      dangerouslySetInnerHTML: {
        __html: message
      }
    })));
  };

  return FormTextArea;
}(PureComponent);

FormTextArea.propTypes = {
  /** The textarea's id, required for a11y */
  id: PropTypes.string.isRequired,

  /** The textarea's label, required for a11y */
  label: PropTypes.string.isRequired,

  /** The actual content of the textarea */
  value: PropTypes.string,

  /** The height, in number of lines, to make the textarea. This is also the minimum size for autoExpand textareas */
  rows: PropTypes.number,

  /** A flag to make the textarea control expand its height to fit the content */
  autoExpand: PropTypes.bool,

  /** The height as a string, in a CSS unit (px, em, vh...) to limit the textarea's height. Can be left blank, zero, or negative for no limit. */
  maxHeight: PropTypes.string,

  /** The maximum height, in number of lines, to make the textarea. This will be trumped by maxHeight */
  maxRows: PropTypes.number,

  /** For form controls with no visible label, set this to true. Make sure to still add a value to the label property. For screen readers. */
  srOnlyLabel: PropTypes.bool,

  /** When populated with a string, this will display a help message beneath the input */
  helpText: PropTypes.string,

  /** When populated with a string, this will turn the border red and display a validation error beneath the input */
  errorMsg: PropTypes.string,

  /** Flag to make helpText and errorMsg use white text for better a11y contrast when used on dark backgrounds */
  inverse: PropTypes.bool,

  /** Called when the value property changes */
  onChange: PropTypes.func,

  /** Called when the textarea gains focus */
  onFocus: PropTypes.func,

  /** Called when textarea loses focus */
  onBlur: PropTypes.func
};
FormTextArea.defaultProps = {
  autoExpand: false,
  srOnlyLabel: false
};
export default FormTextArea;